import { reduce } from 'lodash/fp';

import getIsProductUnavailable from '../get-is-product-unavailable';

// @ts-expect-error - Automatic, Please fix when editing this file
const reduceWithIndex = reduce.convert({ cap: false });
const INITIAL_VALUE = 0;

// @ts-expect-error - Automatic, Please fix when editing this file
const getNextAvailable = ({ products, customerExcess, currentIndex }) =>
  reduceWithIndex(
    // @ts-expect-error - Automatic, Please fix when editing this file
    (currentClosest, product, productIndex) => {
      const isProductUnavailable = getIsProductUnavailable({ customerExcess, product });
      if (isProductUnavailable) {
        return currentClosest;
      }
      // checks if the current product in the loop is closer than the current closest product id
      const comparison = Math.abs(productIndex - (currentIndex + 1)) < Math.abs(currentClosest - (currentIndex + 1));
      return comparison ? productIndex : currentClosest;
    },
    INITIAL_VALUE,
    products,
  );

/**
 * Returns the index of the closest available product in the product comparer, so the user always sees an available product first.
 *
 * @param {object} param - An object.
 * @param {number} param.customerExcess - The current selected excess from the redux customer state.
 * @param {object[]} param.products - Products retrieved from redux for the comparer needs type.
 * @param {number} param.currentIndex - The current index position the comparer is set to.
 */
// @ts-expect-error - Automatic, Please fix when editing this file
const getAvailableProductIndex = ({ currentIndex, customerExcess, products }) => {
  const focusedProduct = products[currentIndex];
  const isFocusedProductUnavailable = getIsProductUnavailable({ customerExcess, product: focusedProduct });
  return isFocusedProductUnavailable ? getNextAvailable({ currentIndex, customerExcess, products }) : currentIndex;
};

export default getAvailableProductIndex;
